<script setup>
import {defineModel} from 'vue'
import BaseSubIcon from "@/components/UI/svg/subscriptions/BaseSubIcon.vue";
import PremiumSubIcon from "@/components/UI/svg/subscriptions/PremiumSubIcon.vue";
import StandardSubIcon from "@/components/UI/svg/subscriptions/StandardSubIcon.vue";


const subs = defineModel('subs')

const selectedSub = defineModel('selected-sub')


const nameToSvg = [
    {
        name: 'Базовый',
        svg: BaseSubIcon,
    },
    {
        name: 'Стандартный',
        svg: StandardSubIcon,
    },
    {
        name: 'Премиум',
        svg: PremiumSubIcon,
    },
]


function findSvgByName(name) {
    return nameToSvg.find((element) => element.name === name)
}

function selectSub(sub) {
    selectedSub.value = sub
}

</script>

<template>
    <div class="w-full flex flex-col items-center justify-center">
        <div class="w-full bg-white p-4 lg:p-[25px] border border-[#e1e1e1] rounded-[16px]">
            <div class="font-bold text-[18px] lg:text-[20px] mb-4 lg:mb-[32px]">Выберите тариф</div>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 lg:gap-[16px] w-full">
                <div
                    class="flex flex-col justify-center p-3 lg:p-[18px] border-2 w-full rounded-[16px] relative cursor-pointer duration-200 transition-all"
                    :class="{
                    'bg-blue-50 border-blue-500': sub === selectedSub,
                    'border-[#e1e1e1] hover:border-blue-300 hover:bg-[#eff8ff]': sub !== selectedSub,
                }"
                    v-for="sub in subs" v-bind:key="sub"
                    v-on:click="selectSub(sub)"
                >
                    <div class="flex items-center gap-2">
                        <div class="size-8 lg:size-10 bg-[#edf2ff] flex items-center justify-center rounded-[12px] flex-shrink-0">
                            <component :is="findSvgByName(sub.name).svg" class="size-4 lg:size-5 stroke-black" />
                        </div>
                        <div>
                            <div class="font-bold text-[13px] lg:text-[14px]">
                                {{ sub.name }}
                            </div>
                            <div class="text-[11px] lg:text-[12px] text-[#555555]">
                                {{ sub.transactions_rate_per_month }} транз/мес
                            </div>
                        </div>
                    </div>
                    <div class="my-2 lg:my-[8px]">
                        <span class="font-bold text-[18px] lg:text-[20px]">{{ sub.price_per_month }}</span> ₽/мес
                    </div>
                    <div>
                        <span class="text-[11px] lg:text-[12px] text-[#555555]">Сверх плана: {{ sub.price_per_transaction }} ₽/транз.</span>
                    </div>
                    <div
                        v-if="sub.name === 'Стандартный'"
                        class="absolute rounded-full bg-blue-500 px-2 py-1 font-bold text-white text-xs top-0 right-0 translate-x-1/2 -translate-y-1/2"
                    >
                        Хит
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>

</style>